var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconQuantumProtocol(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    fill: "url(#paint0_linear_18_2089)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5H36C42.3513 0.5 47.5 5.64873 47.5 12V36C47.5 42.3513 42.3513 47.5 36 47.5H12C5.64873 47.5 0.5 42.3513 0.5 36V12C0.5 5.64873 5.64873 0.5 12 0.5Z",
    stroke: "url(#paint1_linear_18_2089)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18_2089)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_18_2089",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 12,
    width: 24,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36 12H12V36H36V12Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_18_2089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.91 22.7209H26.82V15.5209C26.82 13.8409 25.91 13.5009 24.8 14.7609L24 15.6709L17.23 23.3709C16.3 24.4209 16.69 25.2809 18.09 25.2809H21.18V32.4809C21.18 34.1609 22.09 34.5009 23.2 33.2409L24 32.3309L30.77 24.6309C31.7 23.5809 31.31 22.7209 29.91 22.7209Z",
    fill: "#34D399"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_18_2089",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041D15"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_18_2089",
    x1: 24,
    y1: 0,
    x2: 24,
    y2: 41.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#34D399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18_2089"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQuantumProtocol);
export default __webpack_public_path__ + "static/media/icon-quantum-protocol.a2a244458faed301306c8cd3782773b2.svg";
export { ForwardRef as ReactComponent };